import { render, staticRenderFns } from "./TiposActividad.vue?vue&type=template&id=0002bfb8&"
import script from "./TiposActividad.vue?vue&type=script&lang=ts&"
export * from "./TiposActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0002bfb8', component.options)
    } else {
      api.reload('0002bfb8', component.options)
    }
    module.hot.accept("./TiposActividad.vue?vue&type=template&id=0002bfb8&", function () {
      api.rerender('0002bfb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/Step/TiposActividad.vue"
export default component.exports